import { render, staticRenderFns } from "./collapseBtn.vue?vue&type=template&id=eec8221c&"
import script from "./collapseBtn.vue?vue&type=script&lang=js&"
export * from "./collapseBtn.vue?vue&type=script&lang=js&"
import style0 from "./collapseBtn.vue?vue&type=style&index=0&id=eec8221c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports